import React from 'react'

const CusParagraph = (props) => {
    return (   
        <div className="dcPg fbaPSize">        
            <div style={{fontSize:'0.8em'}}>{props.lblname}</div>
        </div>
    )
}

export default CusParagraph
